import _ from 'lodash';
import type { AdresseType } from '@/types';

type TiersReglement = {
  identifiant: string | number;
  nom: string;
  prenom: string;
  adresse: AdresseType;
};

type ErrorFieldType = {
  field: string;
  message: string;
  itemId: string | number;
};

const validateTiers = (tiers: TiersReglement) => {
  const errors: ErrorFieldType[] = [];
  const { identifiant, nom, prenom, adresse } = tiers;

  if (_.isEmpty(nom) && _.isEmpty(prenom)) {
    errors.push({
      itemId: identifiant,
      field: 'nom',
      message: 'Le nom et le prénom sont obligatoires',
    });
  } else {
    if (_.isEmpty(nom)) {
      errors.push({
        itemId: identifiant,
        field: 'nom',
        message: 'Le nom est obligatoire',
      });
    }
    if (_.isEmpty(prenom)) {
      errors.push({
        itemId: identifiant,
        field: 'nom',
        message: 'Le prénom est obligatoire',
      });
    }
  }

  if (_.isEmpty(adresse)) {
    errors.push({
      itemId: identifiant,
      field: 'nom',
      message: "L'adresse est obligatoire",
    });
  }

  return errors;
};

export default validateTiers;
